import { useTranslation } from "react-i18next"

export default function MoneyBackGuarantee() {
  const { t } = useTranslation()

  return (
    <div className="rounded-3xl bg-gradient-to-br from-green-50 to-blue-50 p-8 text-center shadow-sm">
      <h2 className="mb-6 text-2xl font-bold text-black sm:text-3xl">
        {t("pages.checkout.plans.moneyBackGuaranteeComponent.title")}
      </h2>
      <p className="text-base leading-relaxed text-gray-800 sm:text-lg">
        {t("pages.checkout.plans.moneyBackGuaranteeComponent.description")}
      </p>
    </div>
  )
}
